import React, { Component } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import { useStyles } from "../../../Components/CSS/UserDetailStyle.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import { url } from "../../../Config/Config";
import CustomEmptyMessage from "../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../Components/CustomSiteLoader/CustomSiteLoader";
import SyllabusCards from "./SyllabusCards/SyllabusCards";
import { getUserRefreshToken } from "../../../Redux/Actions/actions";
import PageTitle from "../../../Components/PageTitle/PageTitle";

class UserSyallabus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      academics: [],
      viewStatus: "Syllabus",
    };
  }

  componentDidMount() {
    this.getUserSyllabus();
  }

  getUserSyllabus = async () => {
    try {
      let academicResponse = [];
      if (this.props.role === "Teacher") {
        const response = await Axios.get(`${url}/api/academics`, {
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        });
        academicResponse = response.data.academics;
      } else {
        const responseStudent = await Axios.get(
          `${url}/api/students/${this.props.userId}`,
          {
            headers: { Authorization: `Bearer ${this.props.userToken}` },
          }
        );
        const response = await Axios.get(`${url}/api/academics`, {
          params: {
            studentClass: responseStudent.data.student.studentClass,
            faculty: responseStudent.data.student.faculty
              ? responseStudent.data.student.faculty
              : "",
            group: responseStudent.data.student.group
              ? responseStudent.data.student.group
              : "",
          },
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        });
        academicResponse = response.data.academics;
      }

      if (academicResponse.length !== 0) {
        this.setState({
          academics: academicResponse,
          isEmpty: false,
        });
      } else {
        this.setState({
          academics: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getUserSyllabus();
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { viewStatus } = this.state;
    const syllabusFiltered = this.state.academics.filter(
      (filter) => filter.fileCategory === "Syllabus"
    );
    const modelFiltered = this.state.academics.filter(
      (filter) => filter.fileCategory === "Model Questions"
    );
    const otherFiltered = this.state.academics.filter(
      (filter) => filter.fileCategory === "Others"
    );
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div className={classes.sectionDesktop}>
            <PageTitle
              title="Syllabus, Model and Many More"
              refreshUrl={this.props.match.url}
            />
          </div>
          {this.state.academics.length !== 0 ? (
            <div>
              <TextField
                name="viewStatus"
                select
                required
                fullWidth
                label="What do you want? "
                variant="outlined"
                margin="normal"
                SelectProps={{ native: true }}
                style={{ marginRight: 10 }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.viewStatus}
                onChange={(e) => this.setState({ viewStatus: e.target.value })}
              >
                <option value="">Select Any One</option>
                <option value="Syllabus">Syllabus</option>
                <option value="Model Questions">Model Questions</option>
                <option value="Others">Others</option>
                <option value="All">All</option>
              </TextField>
              <div>
                {viewStatus === "All" ? (
                  <div>
                    <SyllabusCards
                      cardType="Syllabus"
                      cardData={syllabusFiltered}
                    />

                    <SyllabusCards
                      cardType="Model Questions"
                      cardData={modelFiltered}
                    />

                    <SyllabusCards
                      cardType="Extra Materials"
                      cardData={otherFiltered}
                    />
                  </div>
                ) : viewStatus === "Syllabus" ? (
                  <SyllabusCards
                    cardType="Syllabus"
                    cardData={syllabusFiltered}
                  />
                ) : viewStatus === "Model Questions" ? (
                  <SyllabusCards
                    cardType="Model Questions"
                    cardData={modelFiltered}
                  />
                ) : (
                  viewStatus === "Others" && (
                    <SyllabusCards
                      cardType="Extra Materials"
                      cardData={otherFiltered}
                    />
                  )
                )}
              </div>
            </div>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(UserSyallabus));
